import generateContext, { createAction } from '..';

interface IFeatureFlaggingState {
  isTestRestaurant: boolean
}

const initialState: IFeatureFlaggingState = {
    isTestRestaurant: false
};

enum FeatureFlaggingActionType {
  SetTestRestaurant = 'SET_TEST_RESTAURANT',
}

const reducer = (
  state: IFeatureFlaggingState,
  action: { type: FeatureFlaggingActionType; payload?: any }
): IFeatureFlaggingState => {
  switch (action.type) {
    case FeatureFlaggingActionType.SetTestRestaurant:
        state.isTestRestaurant = action.payload;
      return {
        ...state,
      };

    default:
      return state;
  }
};

const [FeatureFlaggingCtxProvider, useFeatureFlaggingState, useFeatureFlaggingDispatch] =
  generateContext(reducer, initialState);

const useFeatureFlaggingActions = () => {
  const dispatch = useFeatureFlaggingDispatch();


  const setIsTestRestaurant = (isTestRestaurant: boolean) => {
    dispatch(createAction(FeatureFlaggingActionType.SetTestRestaurant,isTestRestaurant));
  };

  return {
    setIsTestRestaurant,
  };
};

export { FeatureFlaggingCtxProvider, useFeatureFlaggingState, useFeatureFlaggingActions };
